/* eslint-disable prettier/prettier */
const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: 'light',
  loader: false,
  notification: false,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

export default changeState
